import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import { createMemoryHistory as createHistory } from 'history';
import React from 'react';
import Router from './Router';
/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = createHistory(_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(Router, {
      children: this.props.children,
      history: this.history
    });
  };

  return MemoryRouter;
}(React.Component);

export default MemoryRouter;